// C 側の段階番号を人の読む言葉にする。視聴と走査の両方が同じ番号を使う。
//
// **止まっている場所を出せないと、無言で固まったようにしか見えない。**
// セッションを開く段階（ファームウェアの投入、デバイスを開く、初期化）は
// 数秒かかることがあり、そこで詰まったときに何も出ないと打つ手が無い。

export const STAGE_LABEL: readonly string[] = [
  '開始', 'ファームウェア', 'デバイスを開く', '初期化', 'カード', 'B25',
  '受信機を開く', '選局', 'ロック待ち', 'データプレーン', '接続', '受信中',
  '後始末', '後始末', '完了',
];

export function stageLabel(stage: number): string {
  return STAGE_LABEL[stage] ?? String(stage);
}
